export const getIsProduction = (): boolean => process.env.ENV === 'prd';
